module.exports = __webpack_public_path__ + "static/media/place-holder-curso.e3f1d628.png";